import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./stylesheet/ClientPortal.css";

// Importação dos ícones SVG e Logo
import logoSvg from "../assets/logo.svg";
import ticketsIcon from "../assets/tickets-icon.svg"; // O mesmo usado no Admin
import eventsIcon from "../assets/events-icon.svg";   // O mesmo usado no Admin

export default function ClientPortal() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const accessUser = localStorage.getItem("accessUser");
    if (!accessUser) {
      navigate("/");
      return;
    }
    const parsedUser = JSON.parse(accessUser);
    setUserName(parsedUser.name);
  }, [navigate]);

  function logout() {
    localStorage.removeItem("accessUser");
    navigate("/");
  }

  return (
    <div className="client-portal-page">
      {/* --- CABEÇALHO --- */}
      <header className="portal-header">
        <div className="header-logo-group">
          <img src={logoSvg} alt="Logo" className="portal-logo-svg" />
        </div>

        <div className="header-user-info">
          <span className="user-greeting">Olá, <strong>{userName}</strong></span>
          <button onClick={logout} className="portal-logout-button">Sair</button>
        </div>
      </header>

      {/* --- CONTEÚDO --- */}
      <main className="portal-content">
        <div className="content-intro">
          <h1 className="content-title">O que você precisa?</h1>
          <p className="content-subtitle">Selecione uma opção abaixo para continuar</p>
        </div>

        <div className="portal-action-grid">
          {/* ABRIR CHAMADO */}
          <button
            className="portal-action-card"
            onClick={() => navigate("/abrir-chamado")}
          >
            <div className="portal-icon-wrapper blue-gradient">
              <img src={ticketsIcon} alt="Chamado" className="portal-svg-icon" />
            </div>
            <h2 className="portal-card-title">Abrir Chamado</h2>
            <p className="portal-card-desc">
              Solicite suporte técnico para resolver problemas de TI,
              equipamentos e infraestrutura.
            </p>
            <span className="portal-card-link">Iniciar solicitação →</span>
          </button>

          {/* AGENDAR EVENTO */}
          <button
            className="portal-action-card"
            onClick={() => navigate("/agendar-evento")}
          >
            <div className="portal-icon-wrapper purple-gradient">
              <img src={eventsIcon} alt="Evento" className="portal-svg-icon" />
            </div>
            <h2 className="portal-card-title">Agendar Evento</h2>
            <p className="portal-card-desc">
              Reserve recursos como som, microfone, datashow e outros
              equipamentos para seu evento.
            </p>
            <span className="portal-card-link">Reservar recursos →</span>
          </button>
        </div>
      </main>
    </div>
  );
}